import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import PostUser from 'flarum/forum/components/PostUser';
import UserCard from 'flarum/forum/components/UserCard';
import rankLabel from '../common/helpers/rankLabel';
import Icon from 'flarum/common/components/Icon';
export default function () {
  const matchClass = className => {
    return node => node && node.attrs && node.attrs.className && String(node.attrs.className).split(' ').includes(className);
  };
  const findMatchClass = function (node, className) {
    const arr = [];
    if (node && node.children && Array.isArray(node.children)) {
      const nodeInChildren = node.children.find(matchClass(className));
      if (nodeInChildren) {
        arr.push(nodeInChildren);
      }
      node.children.forEach(function (currentValue) {
        arr.push(...findMatchClass(currentValue, className));
      });
    }
    return arr;
  };
  extend(UserCard.prototype, 'infoItems', function (items) {
    const user = this.attrs.user;
    items.add('points', m("div", null, m(Icon, {
      name: "fas fa-medal"
    }), app.translator.trans('fof-gamification.forum.user.card.points', {
      count: user.points()
    })), 50);
  });
  extend(UserCard.prototype, 'view', function (vnode) {
    var _app$forum$attribute;
    const user = this.attrs.user;
    const profile_node = findMatchClass(vnode, 'UserCard-profile')[0];
    const amt = (_app$forum$attribute = app.forum.attribute('fof-gamification.rankAmt')) != null ? _app$forum$attribute : user.ranks().length;
    if (!profile_node) return;
    let badges_node = profile_node.children.find(matchClass('UserCard-badges'));
    if (user.ranks()) {
      if (!badges_node) {
        profile_node.children.splice(1, 0, m("ul", {
          className: "UserCard-badges badges"
        }, user.ranks().reverse().map((rank, i) => {
          if (!amt || i < amt) {
            return m("li", {
              className: "User-Rank"
            }, rankLabel(rank));
          }
        })));
      } else {
        user.ranks().reverse().map((rank, i) => {
          if (!amt || i < amt) {
            return m("li", {
              className: "User-Rank"
            }, rankLabel(rank));
          }
        }).forEach(rank => {
          if (!rank) {
            return;
          }
          badges_node.children.push(rank);
        });
      }
    }
    return vnode;
  });
  extend(PostUser.prototype, 'view', function (vnode) {
    var _app$forum$attribute2;
    const post = this.attrs.post;
    const user = post.user();
    if (!user) {
      return vnode;
    }
    const header_node = vnode.children.find(matchClass('PostUser-name'));
    const amt = (_app$forum$attribute2 = app.forum.attribute('fof-gamification.rankAmt')) != null ? _app$forum$attribute2 : user.ranks().length;
    if (!user.ranks()) return;
    header_node.children = header_node.children.concat(user.ranks().reverse().splice(0, amt).map(rank => {
      return m("span", {
        className: "Post-Rank"
      }, rankLabel(rank));
    })).filter(function (el) {
      return el.tag !== undefined;
    });
  });
}